import React from 'react'
import { useMyContext } from '../MyContextFile';
import { NavLink } from 'react-router-dom';
import imageUrl from  '../assets/logo.png';





 function Infos() {
  const context = useMyContext();
  if (!context) {
    // Gérer le cas où le contexte est null ou non défini
    return <div>Error: Context is not available</div>;
  }
  return (
    <div>
    
        

        <header className="App">
    
    
        <nav className="navbar-nav navbar navbar-expand-lg navbar-light bg-light ">   
     
        
          
          <NavLink className="navbar-brand" to="/accueil">
            <img
              className="logo-ifc"
              src={imageUrl}
              alt="logo ifc"
             
              width='60px'
            />
          </NavLink >
          
        
          <ul className="nav navbar-nav">
            <li className="">
              <NavLink to="/accueil">Accueil</NavLink>
            </li>
            <li className="">
              <NavLink to="/Examen">Faqs</NavLink>
            </li>
            <li className="">
              <NavLink to="/Contact">Contact</NavLink>
            </li>
            
            <li className="">
              <NavLink to="/faq/">S'inscrire</NavLink>
            </li>
          </ul>
        
      
    </nav>
    </header>
        <section className="section normalhead" data-class="transheader bgcolor">
      <div className="">

     
     
        <section class="section normalhead" data-class="transheader bgcolor">
     
      <div class="col-md-12 col-sm-12 text-center">
      <h2 style={{ fontSize: '2em', fontWeight: 'bold', color: '#25437e' }}> Formulaire d'inscription</h2>
<br/>
<p >Remplissez chaque champ, avec justesse pour un parcours sans  faille.
Votre succès commence par chaque détail.</p>
         
      
      </div>
      </section>
  
    </div>
    </section>
   
    </div>
  )
}
    
 
export default Infos;

